import { render, staticRenderFns } from "./CreateGlobeOperationFolder.vue?vue&type=template&id=5f22804f&scoped=true&"
import script from "./CreateGlobeOperationFolder.vue?vue&type=script&lang=js&"
export * from "./CreateGlobeOperationFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f22804f",
  null
  
)

export default component.exports